<template>
  <div>
    <b-card>
      <div slot="header" v-if="!add && lock">
        Setting Detail
      </div>
      <div slot="header" v-if="!add && !lock">
        Modify Setting
      </div>
      <div slot="header" v-if="add && !lock">
        Register Setting
      </div>

      <b-row v-if="!add">
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_created_at">Created At</label>
            <b-input type="text" v-bind:value="model.created_at | datetime" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!add">
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_updated_at">Updated At</label>
            <b-input type="text" v-bind:value="model.updated_at | datetime" plaintext></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_code">Code</label>
            <b-input type="text" id="ph_code" v-model="model.code" :plaintext="lock" placeholder="Title"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group class="text-primary">
            <label for="ph_data">Data</label>
            <b-textarea type="text" v-if="!lock" id="ph_data" v-model="model.value" placeholder="Contents..." rows="5"></b-textarea>
            <b-textarea type="text" v-if="lock" v-model="model.value" plaintext></b-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button size="sm" variant="light" @click="back"> Back </b-button>
      <template v-if="lock">
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="primary" @click="edit"> Modify </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true"> Delete </b-button>
        </div>
      </template>
      <template v-else>
        <div class="float-right">
          <b-button class="mr-1" size="sm" variant="danger" @click="cancel"> Cancel </b-button>
          <b-button size="sm" variant="primary" @click="save"> Save </b-button>
        </div>
      </template>
    </b-card>
    <b-modal title="Confirm - Delete user account" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      Deleted data cannot be reversed. Are you sure?
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { api, auth } from '@/f1/service';
import 'vue-select/dist/vue-select.css';

const default_model = () => ({ is_use: true, permission: 'User' });
export default {
  components: { cSwitch, vSelect},
  data : () => ({
      confirm: false,
      add: false,
      lock: true,
      model : default_model(),
      allowed: false,
      profile: auth.profile
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'setting', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'setting', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        await api.setting.delete(this.model.id);
        this.$emit('refresh'); this.$toastr.s('Setting deleted.'); this.list();
      } catch(e) { this.$toastr.e(e.data || e); this.list(); }
    },
    back() { this.$router.go(-1); },
    list() { this.$router.push({ name: 'setting'}); },
    async save() {
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Code required.'); }
      if(!(this.model.value || '').trim()) { return this.$toastr.e('Data required.'); }
      try {
        if(this.model.id) { await api.setting.update(this.model); }
        else { this.model.id = +(await api.setting.add(this.model)); }
        this.$toastr.s('Done.'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data || e); this.cancel(); }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');
      try { this.model = Object.assign({},this.model, await api.setting.get(id)); }
      catch(e) { this.$toastr.e(e.data || e); this.list(); }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from) } },
  created() { },
  destroyed() { },
  mounted() {
    this.get(this.$route.params);
  },
}
</script>
